import React, { useEffect } from 'react';
import { useAccount } from '../../contexts/account/AccountContexts';
import Intercom from '@intercom/messenger-js-sdk';
import { transformToIntercomUser } from '../../services/intercom/transformUser';
import { REACT_APP_INTERCOM_ENABLED, REACT_APP_INTERCOM_MESSENGER_ENABLED, REACT_APP_INTERCOM_APP_ID } from '../../utils/config';

export const IntercomChat = () => {
  const { accountResponse } = useAccount();

  useEffect(() => {
    if (!accountResponse || !REACT_APP_INTERCOM_ENABLED) {
      return;
    }

    // Initialize Intercom with user data and configuration
    Intercom({
      ...transformToIntercomUser(accountResponse),
      app_id: REACT_APP_INTERCOM_APP_ID,
      hide_default_launcher: !REACT_APP_INTERCOM_MESSENGER_ENABLED,
    });

    // Cleanup function
    return () => {
      // Shutdown Intercom when component unmounts
      if (window.Intercom) {
        window.Intercom('shutdown');
      }
    };
  }, [accountResponse]);

  return null;
}; 
